import type { EnvironmentService } from './application/EnvironmentService/EnvironmentService';
import { SegmentService } from './infrastructure/SegmentService';

export const buildSegmentAnalyticsService = ({
  environmentService,
}: {
  environmentService: EnvironmentService;
}) => {
  const appDomain = environmentService.get('PUBLIC_BASE_APP_DOMAIN');
  const segmentApiKey = environmentService.getPossiblyUndefined(
    'PUBLIC_SEGMENT_API_KEY',
  );
  const segmentCdnHost = environmentService.getPossiblyUndefined(
    'PUBLIC_SEGMENT_CDN_HOST',
  );

  if (segmentApiKey && segmentCdnHost) {
    // setting _fs_csp for using Fullstory with CSP header, until we can do this in Segment
    if (typeof window !== 'undefined') {
      window['_fs_csp'] = true;
    }
    return new SegmentService({
      apiKey: segmentApiKey,
      domain: appDomain,
      cdnHost: segmentCdnHost,
    });
  }
  return null;
};
